import { Cancelled, Pending, Tick, TickSquare } from '@berlitz/icons'
import InvisibleText from '@components/InvisibleText'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Status, StyledIcon } from './style'

const LessonStatus: React.FC<{ status: string; pastDate?: boolean }> = ({ status, pastDate }) => {
  const currStatus = (status && status.toLowerCase()) || ''
  switch (currStatus) {
    case 'confirmed':
      return (
        <InvisibleText>
          <Status pastDate={pastDate}>
            <FormattedMessage id="Confirmed" />
            <StyledIcon>{pastDate ? <TickSquare color="brand03" /> : <Tick color="brand02" />}</StyledIcon>
          </Status>
        </InvisibleText>
      )

    case 'pending':
      return (
        <InvisibleText>
          <Status pending>
            <FormattedMessage id="Pending" />
            <StyledIcon>
              <Pending color="brand03" />
            </StyledIcon>
          </Status>
        </InvisibleText>
      )

    case 'cancelled':
      return (
        <InvisibleText>
          <Status pastDate={pastDate} cancelled>
            <FormattedMessage id="Cancelled" />
            <StyledIcon>
              <Cancelled color="brand03" />
            </StyledIcon>
          </Status>
        </InvisibleText>
      )

    default:
      return <></>
  }
}

export default LessonStatus
